import React, { useRef } from 'react'
import "./product-question.scss"
import CustomRadioButton from '../../common/CustomRadioButton'
// import {Tooltip} from "react-tooltip"
import SingleQuestion from './SingleQuestion'
import MultiQuestions from './MultiQuestions'
import ListViewToolTipContent from '../calendar/ListViewToolTipContent'
import Tooltip from '../../common/Tooltip/Tooltip'
import { IoMdInformationCircleOutline } from "react-icons/io";


const MainQueSection = (
  {index,
  quesId,
  question,
  setQuestionsValue,
  questionType,
  setQuestionType,
  handleRemoveQuestion,
  handleChange,
  handleOptionChange,
  handleOptionRadioChange,
  error,
  disabled=false,
  createTest,
  toggleCreateTest,
  handleSubmit,
 
  queIndex,
  questionError,
  quesNumber,
  answerError,
  handleSetQuestionType,
  setAnswerError,

}
  ) => {
    console.log("disabled",disabled)
    const tooltipViewRef = useRef(null);
  return (
    <>
   <div className='main-questions-area'>

      <div className='InputWrapper questionsInputMain'>
        <div>
         <label> Type of question <IoMdInformationCircleOutline id='list-view' /> :</label>
        </div>
        <Tooltip targetId={"#list-view"} place={"bottom-end"}  style={{  background: "#000", maxWidth:"350px"}} toolTipContent={<ListViewToolTipContent className="list-view-tooltip"   toolTipTitle={"Please select the type of question you would like to ask the patient. "} tooltipRef={tooltipViewRef}  ishow = {false}/>} tooltipRef={tooltipViewRef} />
          <Tooltip targetId={"#mcq-list-view"} place={"bottom-end"} style={{  background: "#000" , maxWidth:"350px"}} toolTipContent={<ListViewToolTipContent className="list-view-tooltip" toolTipTitle={"Asking multiple-choice questions helps identify users eligible for treatment or products."} tooltipRef={tooltipViewRef} ishow = {false} />} tooltipRef={tooltipViewRef} />
           <div className='InputField questionsInputWrapper'>
            <div
             data-tooltip-id="warning-tooltip1"
             data-tooltip-content="Please remove all questions to change question type"
             className={`col-12 col-md-auto mt-2 sm-full-colum   ${disabled ? "" : ""} ${(disabled && questionType !== 1) ? "custom-extra-disabled-class" : "custom-extra-unable-class"}`}>
             <CustomRadioButton
              type="radio"
              preselect={true}
               name="que"
               id={`${queIndex}+single`}
               value="1"
               mainQue={true}
               text="Short answer question"
               onChange={() => {
                handleSetQuestionType(1)
                //  setQuestionType(1);
               }}
               checked={questionType === 1 && true}
               disabled={disabled}
             />
            </div>
            {/* {
                    !(disabled && questionType == 1) &&
                    <Tooltip id="warning-tooltip1"
                      className="popular-course-tooltip" effect="solid" place="top" />
            } */}

              <div
                    data-tooltip-id="warning-tooltip2"
                    data-tooltip-content="Please remove all questions to change question type"
                    className={`col-12 col-md-auto mt-2 sm-full-colum ${disabled ? "" : ""} ${(disabled && questionType !== 2) ? "custom-extra-disabled-class" : "custom-extra-unable-class"}`}>
                    <CustomRadioButton
                      type="radio"
                      name="que"
                      preselect={true}
                      id={`${queIndex}+multiple`}
                      value="2"
                      mainQue={true}
                      text={<span>
                        Multiple Choice Questions
                        <IoMdInformationCircleOutline id="mcq-list-view" style={{ cursor: "pointer", marginLeft: "5px" }} />
                      </span>}
                      onChange={() => {
                        handleSetQuestionType(2)
                        // setQuestionType(2);
                      }}
                      checked={questionType === 2 && true}
                      disabled={disabled}
                    />
              </div>

              {/* {
                    !(disabled && questionType == 2) &&
                    <Tooltip id="warning-tooltip2"
                      className="popular-course-tooltip" effect="solid" place="top" />
              } */}

                 <div
                    data-tooltip-id="warning-tooltip3"
                    data-tooltip-content="Please remove all questions to change question type"
                    className={`col-12 col-md-auto mt-2 sm-full-colum ${disabled ? "" : ""} ${(disabled && questionType !== 3) ? "custom-extra-disabled-class" : "custom-extra-unable-class"}`}>
                    <CustomRadioButton
                      type="radio"
                      name="que"
                      preselect={true}
                      id={`${queIndex}+document`}
                      value="3"
                      mainQue={true}
                      text="Image & video uploads"
                      onChange={() => {
                        // setQuestionType(3);
                        handleSetQuestionType(3)
                      }}
                      checked={questionType === 3 && true}
                      disabled={disabled}
                    />
                </div>
                {/* {
                    !(disabled && questionType == 3) &&
                    <Tooltip id="warning-tooltip3"
                      className="popular-course-tooltip" effect="solid" place="top" />
                  } */}
           </div>

          
      </div>
  
      
      {
        questionType === 1 && (
          <SingleQuestion 
            queNo={quesNumber}
            quesId={quesId}
            question={question}
            questionType={questionType}
            handleRemoveQuestion={handleRemoveQuestion}
            handleChange={handleChange}
            error={questionError}
            answerEor={answerError}
          />
        )
      }
    
    {
      questionType === 2 && (
        <MultiQuestions
           queNo={quesNumber}
           quesId={quesId}
           question={question}
           setQuestionsValue={setQuestionsValue}
           handleRemoveQuestion={handleRemoveQuestion}
           handleChange={handleChange}
           handleOptionChange={handleOptionChange}
           handleOptionRadioChange={handleOptionRadioChange}
           handleSubmit={handleSubmit}
           questionType={questionType}
           error={questionError}
           answerEor={answerError}
           setAnswerError={setAnswerError}
         />
      )
    }
    {
      questionType === 3 && (
        <SingleQuestion 
          queNo={quesNumber}
          quesId={quesId}
          question={question}
          handleRemoveQuestion={handleRemoveQuestion}
          handleChange={handleChange}
          questionType={questionType}
          error={questionError}
          answerEor={answerError}
        />
      )
    }
           
           
   </div>
      
    </>
  )
}

export default MainQueSection